module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "loader-bar"
  }, [_c('p', [_vm._v("Veuillez patienter s'il vous plait ...")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4081bfc8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/partials/Loader.vue
// module id = 97
// module chunks = 0